/**
 * POST /api/person/public/zendesk-messaging-jwt?provider=zendesk (no Cognito).
 * Uses a dedicated API GW route with Authorizer NONE; /api/person/me/token still requires JWT.
 */
export async function fetchZendeskMessagingJwt (body) {
  const res = await fetch('/api/person/public/zendesk-messaging-jwt?provider=zendesk', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.message || res.statusText)
  return data
}
